<template>
    <div class="card m-1" >
      <div class="card-body maadi-dark-card">
        <div class="m-2 pb-3 pt-3 d-flex" style="border: 1px solid #3E597A" v-for="member in latestMembers" :key="member.id">
          <single-organization-result-v2 v-bind:organization="member"/>
        </div>
      </div>
    </div>
</template>

<script>
import SingleOrganizationResultV2 from '../organizations/search/SingleOrganizationResult'
import MembershipDashboardMixin from './MembershipDashboardMixin'
export default {
  name: '',
  mixins: [MembershipDashboardMixin],
  components: {SingleOrganizationResultV2},
  computed: {
    latestMembers () {
      let d = new Date()
      d.setDate(d.getDate() - 14)
      let newMembers = this.members.filter((x) => new Date(x.membership_transaction_date) > d)
      return newMembers.sort((a, b) => {
        let aDate = new Date(a.membership_transaction_date)
        let bDate = new Date(b.membership_transaction_date)
        if (aDate < bDate) {
          return 1
        }
        if (aDate > bDate) {
          return -1
        }
        return 0
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/membership/LatestMembers.vue